'use strict';

const {
    PHOTO_UI_UPDATE_DIMENSIONS,
    PHOTO_UI_SHOW_ITEM_TAGS,
    PHOTO_UI_HIDE_ITEM_TAGS,
    PHOTO_UI_SET_ITEM_TAG,
    PHOTO_UI_UNSET_ITEM_TAG} = require('./galleryActionConstants');

const {trackTooltipDisplayed} = require('./galleryTrackingActions');

function updateImageDimensions(ac, payload, done) {
    ac.dispatch(PHOTO_UI_UPDATE_DIMENSIONS, payload);
    done();
}

function showItemTagIndicators(ac, payload, done) {
    ac.dispatch(PHOTO_UI_SHOW_ITEM_TAGS, payload);
    done();
}

function hideItemTagIndicators(ac, payload, done) {
    ac.dispatch(PHOTO_UI_HIDE_ITEM_TAGS, payload);
    done();
}

function flashItemTagIndicators(ac, payload, done) {
    ac.executeAction(showItemTagIndicators);
    setTimeout(() => {
        ac.executeAction(hideItemTagIndicators);
        done();
    }, 5000);
}

function showItemTagTooltip(ac, payload, done) {
    ac.dispatch(PHOTO_UI_SET_ITEM_TAG, payload);
    ac.executeAction(trackTooltipDisplayed, done);
}

function hideItemTagTooltip(ac, payload, done) {
    ac.dispatch(PHOTO_UI_UNSET_ITEM_TAG, payload);
    done();
}


module.exports = {
    updateImageDimensions,
    showItemTagIndicators,
    hideItemTagIndicators,
    flashItemTagIndicators,
    showItemTagTooltip,
    hideItemTagTooltip
};



// WEBPACK FOOTER //
// ./assets/js/gallery/actions/galleryPhotoUIActions.es.js